<template>
  <div v-if="acreditacoes && Array.isArray(acreditacoes)" class="acreditacoes">
    <template v-for="(acreditacao, index) of acreditacoes">
      <img v-if="acreditacao" :key="index" :src="acreditacao.icone" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'Func4Acreditacao',
  props: {
    acreditacoes: []
  }
}
</script>

<style scoped lang="less">
.acreditacoes {
  display: flex;
  padding: 4px 0;
  gap: 1rem;
}
</style>
